import type { ChatMessage } from '@/machines/chatbotMachine'
import { Database, FileText, Image as ImageIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

const CHIP = 'inline-flex max-w-full items-center gap-[0.3em] rounded border border-black/10 bg-white/60 px-[0.4em] py-[0.1em] text-[0.85em] dark:border-white/10 dark:bg-black/20'

/**
 * What the user attached, inside their bubble: pictures as thumbnails, a PDF by name, a Library file as
 * a link to its item.
 */
export function MessageAttachments({ message }: { message: Pick<ChatMessage, 'attachments' | 'attachedFiles'> }) {
  const attachments = message.attachments ?? []
  const files = message.attachedFiles ?? []
  if (attachments.length === 0 && files.length === 0) return null

  return (
    <div className="mt-[0.5em] flex flex-wrap items-start gap-[0.35em]" data-testid="message-attachments">
      {attachments.map((a, i) =>
        a.kind === 'image' ? (
          a.src ? (
            <img
              key={`img-${i}`}
              src={a.src}
              alt="Attached picture"
              className="max-h-32 w-auto rounded-md border border-black/10 dark:border-white/10"
            />
          ) : (
            <span key={`img-${i}`} className={CHIP}>
              <ImageIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
              <span>Picture</span>
            </span>
          )
        ) : (
          <span key={`doc-${i}`} className={CHIP} title={a.name}>
            <FileText className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
            <span className="truncate">{a.name}</span>
          </span>
        ),
      )}
      {files.map(f => (
        <Link key={f.id} to={`/library/file/${f.id}`} className={`${CHIP} hover:underline`} title={f.title}>
          <Database className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span className="truncate">{f.title}</span>
        </Link>
      ))}
    </div>
  )
}
